"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.qualificationSchemaDef = exports.qualificationMinSchemaDef = exports.assessmentSchemaDef = void 0;
const joi_1 = __importDefault(require("joi"));
const general_1 = require("../general");
const BusinessUnit_1 = require("../shared/BusinessUnit");
const schemaValidator_1 = require("../../util/schemaValidator");
exports.assessmentSchemaDef = {
    version: joi_1.default.number().positive().required(),
    code: joi_1.default.string().required(),
    name: joi_1.default.string().required(),
    availableIn: joi_1.default.array(),
};
exports.qualificationMinSchemaDef = {
    _id: general_1.daoObjSchemaDef._id,
    id: joi_1.default.number().positive().required(),
    name: joi_1.default.string().required(),
};
exports.qualificationSchemaDef = Object.assign(Object.assign(Object.assign({}, general_1.daoObjSchemaDef), exports.qualificationMinSchemaDef), { businessUnit: (0, schemaValidator_1.objectSchema)(BusinessUnit_1.businessUnitSchemaDef).required(), assessments: (0, schemaValidator_1.arraySchema)(exports.assessmentSchemaDef).default([]) });
